import { themedUseStyletron } from '../../../theme/customTheme';
import './HeatingPump.css'

export function HeatingPump({ color, height, width }: any) {
    return (
        <svg version="1.0" width={width || '100%'} height={height || '100%'} viewBox="0 0 946.000000 768.000000" preserveAspectRatio="xMidYMid meet">
            <g transform="translate(0.000000,768.000000) scale(0.100000,-0.100000)"
                fill={color} stroke="none">
                <path d="M2835 7656 c-71 -33 -141 -113 -161 -185 -8 -31 -17 -60 -18 -66 -2
-5 -147 -45 -322 -89 -176 -43 -346 -90 -379 -105 -72 -33 -116 -75 -153 -145
l-27 -51 0 -515 0 -515 34 -63 c38 -70 86 -113 158 -142 26 -11 176 -51 333
-90 157 -39 302 -75 323 -81 l37 -10 0 -265 0 -266 -88 -96 c-193 -210 -357
-445 -472 -672 l-30 -60 -289 0 -290 0 -6 58 c-8 65 -40 143 -78 187 -14 17
-49 44 -79 60 l-53 30 -514 3 c-579 3 -572 4 -656 -70 -25 -22 -58 -64 -73
-92 l-27 -51 0 -1410 0 -1410 23 -46 c31 -63 86 -117 152 -148 l55 -26 500 0
c580 0 570 -1 661 89 54 55 77 106 89 204 l7 52 288 0 288 0 57 -107 c386
-732 1098 -1286 1907 -1483 254 -62 373 -75 698 -75 258 0 312 3 436 23 758
121 1397 493 1877 1089 93 116 233 330 297 454 l51 99 288 0 289 0 10 -70 c23
-158 111 -247 266 -271 40 -6 244 -9 523 -7 l458 3 55 26 c66 31 121 85 152
148 l23 46 0 1410 0 1410 -27 51 c-15 28 -48 70 -73 92 -84 74 -77 73 -656 70
l-514 -3 -53 -30 c-30 -16 -65 -43 -79 -60 -38 -44 -70 -122 -78 -187 l-6 -58
-289 0 -288 0 -52 96 c-122 229 -258 422 -434 616 l-106 117 0 1185 c0 1169 0
1186 -20 1240 -26 67 -85 130 -153 162 l-52 24 -1845 0 -1845 0 -50 -24z
m3365 -1357 l0 -781 -92 50 c-770 411 -1701 454 -2511 116 -34 -14 -124 -57
-199 -95 l-138 -69 0 780 0 780 1470 0 1470 0 0 -781z m-3540 201 c0 -154 -3
-280 -6 -280 -5 0 -162 39 -246 61 l-38 10 0 208 0 209 138 35 c75 19 140 36
145 36 4 1 7 -125 7 -279z m2311 -1200 c980 -99 1815 -826 2048 -1782 51 -208
65 -330 65 -563 0 -299 -43 -550 -139 -811 -82 -222 -235 -491 -379 -669 -142
-174 -366 -377 -551 -498 -213 -139 -533 -273 -775 -326 -323 -69 -697 -69
-1020 0 -335 73 -699 250 -975 474 -106 87 -272 252 -350 350 -441 549 -614
1257 -475 1945 124 616 484 1149 1015 1502 298 198 690 340 1036 377 121 12
380 13 500 1z m-4081 -2350 l0 -1030 -145 0 -145 0 0 1030 0 1030 145 0 145 0
0 -1030z m7970 0 l0 -1030 -145 0 -145 0 0 1030 0 1030 145 0 145 0 0 -1030z
m-7013 663 c-70 -387 -87 -582 -69 -828 10 -138 39 -345 68 -482 l7 -33 -282
0 -281 0 0 685 0 685 281 0 281 0 -5 -27z m6323 -658 l0 -685 -281 0 -281 0 6
33 c61 293 85 581 68 821 -10 139 -39 345 -68 484 l-6 32 281 0 281 0 0 -685z"/>
                <path d="M4597 3810 c-424 -72 -729 -429 -730 -855 -1 -478 385 -865 863 -865
336 0 644 198 785 504 148 320 85 700 -159 954 -197 206 -490 307 -759 262z
m224 -404 c213 -46 369 -232 369 -442 0 -65 -17 -154 -29 -154 -3 0 -136 130
-295 289 l-289 289 39 10 c97 25 118 26 205 8z m40 -889 c-4 -4 -36 -13 -70
-19 -165 -31 -363 64 -458 218 -56 92 -78 236 -52 341 l12 45 288 -288 c159
-159 285 -292 280 -297z"/>
            </g>
        </svg>
    );
}

export const HeatingPumpOn = (props: any) => {
    const [css, theme] = themedUseStyletron();
    return (
        <div style={{
            transform: "rotate(90deg)",
            opacity: 0.3
          }}>
            <div className="dot-fire"></div>
        </div>
    );
}